import Swal, { SweetAlertIcon } from 'sweetalert2';
import variables from '../../../../shared/styles/settings.module.scss';

interface ConfirmSwalOptions {
    title: string;
    html: string;
    icon?: SweetAlertIcon;
    confirmText?: string;
    denyText?: string;
    customClass?: string;
    modeTheme: 'darkMode' | 'lightMode';
}

export async function confirmSwalGeneric(
    opts: ConfirmSwalOptions
): Promise<boolean> {
    const {
        title,
        html,
        icon = 'question',
        confirmText = 'ACEPTAR',
        denyText = 'CANCELAR',
        customClass = 'swal-wide-class',
        modeTheme,
    } = opts;

    const color =
        modeTheme === 'darkMode' ? variables.darkColor : variables.primaryColor;

    const res = await Swal.fire({
        title,
        html,
        icon,
        iconColor: color,
        showDenyButton: true,
        denyButtonText: denyText,
        denyButtonColor: color,
        confirmButtonText: confirmText,
        confirmButtonColor: color,
        customClass,
    });

    return !!res.isConfirmed;
}
